import script from "./DayRuneResult.vue?vue&type=script&setup=true&lang=ts"
export * from "./DayRuneResult.vue?vue&type=script&setup=true&lang=ts"

import "./DayRuneResult.vue?vue&type=style&index=0&id=3d39ea66&lang=css"

const __exports__ = script;

export default __exports__